import { render, staticRenderFns } from "./bas0010.vue?vue&type=template&id=031ac9aa&scoped=true"
import script from "./bas0010.vue?vue&type=script&lang=js"
export * from "./bas0010.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ac9aa",
  null
  
)

export default component.exports